import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LoginPage } from './login';
import { LangModule } from 'src/app/modules/lang/lang.module';

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    LangModule
  ],
  declarations: [LoginPage],
  entryComponents: [LoginPage]
})
export class LoginPageModule { }
